import { useCallback, useEffect, useRef, useState } from "react";

const CLOSE_DELAY_MS = 280;

export default function useReactionHover() {
  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredRelike, setIsHoveredRelike] = useState(false);
  const closeTimer = useRef(null);

  const cancelClose = useCallback(() => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  }, []);

  useEffect(() => () => cancelClose(), [cancelClose]);

  const openLikeBar = useCallback(() => {
    cancelClose();
    setIsHoveredRelike(false);
    setIsHovered(true);
  }, [cancelClose]);

  const openRelikeBar = useCallback(() => {
    cancelClose();
    setIsHovered(false);
    setIsHoveredRelike(true);
  }, [cancelClose]);

  const closeLikeBar = useCallback(() => {
    cancelClose();
    closeTimer.current = setTimeout(() => {
      setIsHovered(false);
    }, CLOSE_DELAY_MS);
  }, [cancelClose]);

  const closeRelikeBar = useCallback(() => {
    cancelClose();
    closeTimer.current = setTimeout(() => {
      setIsHoveredRelike(false);
    }, CLOSE_DELAY_MS);
  }, [cancelClose]);

  return {
    isHovered,
    isHoveredRelike,
    setIsHovered,
    setIsHoveredRelike,
    openLikeBar,
    openRelikeBar,
    closeLikeBar,
    closeRelikeBar,
  };
}
